export enum StoreTypes {
    GLS = 0,
    DAO = 1,
    PostDK = 2,
    ClickCollect = 3,
    GiftShop = 4,
}
